import React from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';

export default function PaymentCancelled() {
  const [params] = useSearchParams();
  const invNo = params.get('inv');
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="bg-white rounded-xl shadow-lg p-10 max-w-md w-full text-center" data-testid="payment-cancelled-card">
        <XCircle className="mx-auto text-orange-500 mb-4" size={56} />
        <h1 className="text-2xl font-bold text-gray-900">Payment Cancelled</h1>
        <p className="text-gray-600 mt-2">
          {invNo ? <>Invoice <strong>{invNo}</strong> was not paid.</> : 'The payment was not completed.'}
          {' '}You can pay anytime using the Pay Now link in your invoice.
        </p>
        <Link to="/" className="inline-block mt-6 text-green-700 font-medium hover:underline">Back to NJK Logistics</Link>
      </div>
    </div>
  );
}
